require("!!/Users/weirong/Code/hkaf/hkaf-live-git/angular-admin-portal/node_modules/script-loader/addScript.js")(require("!!/Users/weirong/Code/hkaf/hkaf-live-git/angular-admin-portal/node_modules/raw-loader/index.js!/Users/weirong/Code/hkaf/hkaf-live-git/angular-admin-portal/node_modules/source-map-loader/index.js!/Users/weirong/Code/hkaf/hkaf-live-git/angular-admin-portal/src/assets/js/ace/elements.colorpicker.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/assets/js/ace/elements.colorpicker.js
// module id = 320
// module chunks = 2